/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button, Space, } from 'antd';
import { PoweroffOutlined } from '@ant-design/icons';
import { clearLogin } from '../../core/authUtil';
import Actions from '../../actions';

const Profile = ({ user }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /**
   * 调接口 - 获取用户信息
   */
  const initUserInfo = async () => {
    const action = await Actions.getAuthProfile();
    dispatch(action);
  }

  useEffect(() => {
    initUserInfo();
  }, []);

  const logout = async () => {
    clearLogin();
    await Actions.logout();
    navigate('/login')
  }

  const { id, userName } = user;
  if (id) {
    return (
      <div className="profile">
        <Space>
          <div className="user-name">你好，{userName}</div>
          <Button className="btn-logout" type="link" icon={<PoweroffOutlined />} onClick={logout}>登出</Button>
        </Space>
      </div>
    )
  }
  return null;
}

const store = (state) => {
  console.log('Profile,state', state);
  const { auth } = state;
  return auth;
}

export default connect(store)(Profile);